import {
    Directive,
    EventEmitter,
    OnInit,
    Output,
    Input,
    OnDestroy,
    ElementRef,
    AfterViewInit
} from "@angular/core";
import { DragulaService } from "ng2-dragula";
import { Subscription } from 'rxjs';
import { Draggable } from '../models/draggable.model';

@Directive({
    selector: "ngx-datatable[dragulaName]",
    standalone: true
})
export class NgxDradDropDirective implements OnInit, AfterViewInit, OnDestroy {
    @Input() public dragulaName: string;
    @Input() public dragulaModel: any[];
    @Input() public classSelector: string = "null";
    @Output() public directiveDrop: EventEmitter<any> = new EventEmitter<any>();

    private container: any;
    private subs = new Subscription();
    private setupAttempts = 0;
    private maxAttempts = 20; // Increased from 10
    private setupTimeout: any = null;

    constructor(
        private el: ElementRef,
        private dragulaService: DragulaService
    ) {}

    ngOnInit() {
        // Clean up any existing dragula group
        if (this.dragulaService.find(this.dragulaName)) {
            this.dragulaService.destroy(this.dragulaName);
        }
    }

    ngAfterViewInit() {
        setTimeout(() => this.trySetupDragula(), 200);
    }

    private trySetupDragula() {
        if (this.setupAttempts >= this.maxAttempts) {
            console.warn('Max attempts reached trying to setup dragula');
            return;
        }
        this.container = this.el.nativeElement.querySelector(".datatable-scroll") || // Try parent first
        this.el.nativeElement.querySelector(".ngx-datatable");
        
        if (!this.container) {
            this.setupAttempts++;
            setTimeout(() => this.trySetupDragula(), 200);
            return;
        }

        this.setupDragula();
    }

    private setupDragula() {
        this.dragulaService.createGroup(this.dragulaName, {
            moves: (el: any, source: any, handle: any) => {
                const canMove = this.classSelector === "null" ? true : 
                              handle.className.includes(this.classSelector);
                // Log positions before move
                const elementIndex = Array.from(source.children).indexOf(el);
                return canMove;
            },
            accepts: (el: any, target: any, source: any) => target === source,
            direction: 'vertical',
            containers: [this.container]
        });
    
        let dragIndex = -1;
        let draggedItem: any = null;
    
        this.subs.add(
            this.dragulaService.drag(this.dragulaName)
                .subscribe(({ el }) => {
                    dragIndex = Array.from(el.parentElement.children).indexOf(el);
                    draggedItem = this.dragulaModel[dragIndex];
                })
        );
    
        this.subs.add(
            this.dragulaService.drop(this.dragulaName)
                .subscribe(({ el, source }) => {
                    const dropIndex = Array.from(source.children).indexOf(el);
        
                    if (dragIndex !== dropIndex && dragIndex !== -1) {
                        const item = this.dragulaModel[dragIndex];
        
                        this.dragulaModel.splice(dragIndex, 1);
                        this.dragulaModel.splice(dropIndex, 0, item);
        
                        // Update orders
                        this.dragulaModel.forEach((item, index) => {
                            item.order = index + 1;
                        });
        
                        this.directiveDrop.emit({
                            dragIndex,
                            dropIndex,
                            updatedModel: [...this.dragulaModel]
                        });
                    }
                })
        );
        
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
        if (this.dragulaService.find(this.dragulaName)) {
            this.dragulaService.destroy(this.dragulaName);
        }
    }
}